var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mt-2",class:(_vm.showMessageBar?'':'d-none') + '  message-bar',attrs:{"value":_vm.showMessageBar,"transition":"fade-transition","type":_vm.messageClass}},[_vm._v(_vm._s(_vm.currentMessage))])
}
var staticRenderFns = []

export { render, staticRenderFns }